import React from 'react';
import { Handle, Position } from '@xyflow/react';
import Icon from '../../../../utils/icons';
import {truncateString} from '../../../../utils/utility';

const positionMap = {
  left: Position.Left,
  right: Position.Right,
  top: Position.Top,
  bottom: Position.Bottom
};

const baseHandleStyle = {
  background: '#E87828',
  width: 5,
  height: 5,
  border: '2px solid #E87828',
  zIndex: 10
};

const CardNode = ({ data, id }) => {
  const {
    title,
    subtitle,
    border = '#F29A45',
    active,
    positionArray,
    secondary,
    isRemovable,
    deleteHvac,
    fromManageHVACSystem
  } = data;

  const renderHandles = () =>
    positionArray
      ? Object.entries(positionArray).map(([key, value]) => {
          const type = typeof value === 'string' ? value : value?.type;
          if (!positionMap[key] || !['source', 'target'].includes(type)) return null;

          const style = { ...baseHandleStyle };
          if (key === 'left') style.left = -18;
          if (key === 'right') style.right = -18;
          if (key === 'top') style.top = -15;
          if (key === 'bottom') style.bottom = -10;

          return (
            <Handle
              key={key}
              id={key}
              type={type}
              position={positionMap[key]}
              style={style}
            />
          );
        })
      : null;

  const handleRemove = () => {
    const hvacId = id.split('_').pop();
    deleteHvac?.(hvacId);
  };

  return (
    <div className={`node-container ${active ? 'active' : ''}`}>
      <div className={`node-area ${secondary ? 'secondary' : ''}`} style={{ borderColor: border }}>
        {renderHandles()}

        {isRemovable && !fromManageHVACSystem && (
          <div className="delete-hvac-container" onClick={handleRemove}>
            <Icon src="closeCircle" />
          </div>
        )}

        <div className="name-box">
          <div className={`device-type ${secondary ? 'secondary' : ''}`}>{title}</div>
          <div className="device-name">{truncateString(subtitle)}</div>
        </div>
      </div>
    </div>
  );
};

export default CardNode;
